export class ListInstanceTypesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceTypes",
            "baseName": "instanceTypes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInstanceTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
